// extracted by mini-css-extract-plugin
export default {"loader-wrapper":"style_loader-wrapper__G7QrU","welcome":"style_welcome__JpK16","welcome-text":"style_welcome-text__o4f8t","start-btn":"style_start-btn__nWzKg"};